/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import H1 from '@base/H1/H1';
import H4 from '@base/H4/H4';
import Button from '@base/Button/Button';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import { getImage } from '@utils/imageHelper';

const WrapperMain = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(229, 244, 255, 0.44) 100%
  );
  display: flex;
  justify-content: center;
  position: relative;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 32px);
  grid-column-gap: 16px;
  margin: auto;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  grid-column: span 13;
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column-end: 25;
  grid-column-start: 15;
`;

const StyledP1 = styled(P1)`
  margin-top: 16px;
  margin-bottom: 48px;
  font-size: 20px;
`;

const LearningButton = styled(Button)`
  width: auto;
  height: auto;
  padding: 18px 32px;
  font-size: 20px;
  margin-right: 32px;
`;

const ActionsWrap = styled.div`
  display: flex;
  align-items: center;
`;

const BlueH4 = styled(H4)`
  font-size: 16px;
  line-height: 150%;
  color: var(--color-i-blue);
`;

const StyledRightImg = styled.img`
  opacity: 1;
  @media only screen and (max-width: 1336px) {
    opacity: 0;
  }
`;

const StyledAbsoluteImg = styled.img`
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0;
  @media only screen and (max-width: 1336px) {
    opacity: 1;
  }
`;

const FirstSection = ({ openAccountDrawer }) => {
  const onClick = () => {
    openAccountDrawer();
  };
  const onClickLogin = () => {
    openAccountDrawer('login');
  };
  return (
    <WrapperMain>
      <Wrapper>
        <LeftWrapper>
          {/* <img
            src={getImage('classroom/teach.png')}
            alt=""
            width="100"
            height="51"
            style={{ marginBottom: '16px' }}
          /> */}
          <H1>
            A new classroom for
            <br />
            you and your students
          </H1>
          <StyledP1>
            For a more accessible, and powerful learning environment for your
            students.
          </StyledP1>
          <ActionsWrap>
            <LearningButton
              label="Sign up to Teach"
              color="blue"
              onClick={onClick}
            />
            <UnderlineLink
              color="var(--color-i-blue)"
              onClick={onClickLogin}
              href=""
            >
              <BlueH4>I have an account</BlueH4>
            </UnderlineLink>
          </ActionsWrap>
        </LeftWrapper>
        <RightWrapper>
          <StyledRightImg
            src={getImage('classroom/teach_side.png')}
            alt="Teach Side"
            height="591"
          />
        </RightWrapper>
      </Wrapper>
      <StyledAbsoluteImg
        src={getImage('classroom/teach_side.png')}
        alt="Teach Side"
        height="591"
      />
    </WrapperMain>
  );
};

export default FirstSection;
